var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[(_vm.searchValue)?_c('div',{staticClass:"search__body"},[_c('p',{staticClass:"color__charcoal",class:{
            'text-baseMedium': !_vm.isDesktop,
            'text-xlSemibold-2': _vm.isDesktop
        }},[_vm._v("\n            "+_vm._s(_vm.computedTextSearching)+"\n        ")]),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.list.length === 0),expression:"list.length === 0"}],staticClass:"color__moon mt__8",class:{
            'text-lRegular': !_vm.isDesktop,
            'text-lMedium': _vm.isDesktop
        }},[_vm._v(_vm._s(_vm.$t('cleaning_search_suggestion')))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }